import * as React from "react";
import "./Icon.css";
const SvgFilterIcon = ({ width, height, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 48 48"
    width={width || undefined}
    height={height ? height : "auto"}
    fill="currentColor"
    {...props}
    className={`svg-icon ${props.className || ""}`}
    style={{
      transformOrigin: "center",
      ...props.style,
      ...(width ? { width: width } : {}),
      ...(height ? { height: height } : {}),
    }}
  >
    <defs>
      <style>
        {
          ".Filter_Icon_svg_cls-1{fill:none;stroke-miterlimit:10;stroke-width:2px;stroke:currentColor}.Filter_Icon_svg_cls-2{fill:currentColor;,stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"
        }
      </style>
    </defs>
    <g transform="translate(1,5)">
      <circle cx={37.25} cy={5.82} r={4.82} className="Filter_Icon_svg_cls-1" />
      <path
        d="M32.56 5.82A4.45 4.45 0 0 1 33 3.89H.5v3.86H33a4.5 4.5 0 0 1-.44-1.93M41.26 3.89a4.45 4.45 0 0 1 0 3.86h5V3.89ZM5.34 19.82a4.6 4.6 0 0 1 .44-1.93H.5v3.86h5.28a4.6 4.6 0 0 1-.44-1.93M14 17.89a4.45 4.45 0 0 1 0 3.86h32.3v-3.86ZM26.5 33.82a4.45 4.45 0 0 1 .44-1.93H.5v3.86h26.44a4.5 4.5 0 0 1-.44-1.93M35.19 31.89a4.36 4.36 0 0 1 0 3.86H46.3v-3.86Z"
        className="Filter_Icon_svg_cls-2"
      />
      <circle cx={9.95} cy={19.82} r={4.82} className="Filter_Icon_svg_cls-1" />
      <circle
        cx={30.97}
        cy={33.82}
        r={4.82}
        className="Filter_Icon_svg_cls-1"
      />
    </g>
  </svg>
);
export default SvgFilterIcon;
